export default {
  existingVettingRequestsMap({ vettings }) {
    return vettings.reduce(
      (acc, current) => ({
        ...acc,
        [`${current.evp_id}-${current.vetting_class}`]: true,
      }),
      {}
    );
  },
};
